// Which audience a resource's content was made for. Mirrors the
// `resources_designed_for_check` CHECK constraint (apps/server/drizzle/0267).
// A NULL column means not yet reviewed — never treated as 'all_users'.
export const RESOURCE_DESIGNED_FOR = ['all_users', 'women'];
//# sourceMappingURL=resource-designed-for.js.map